import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { accountActions } from '../../redux/actions';
import { Modal, Row, Checkbox, Input, Typography } from 'antd';
import Localization from '../../utils/localization';
import AccountPickerByNumber  from '../AccountPickerByNumber';
import './styles.scss';

const { Title } = Typography;

const ChooseSumType = ({ accountStructure, isChooseSumTypeOpen, setIsChooseSumTypeOpen, mainAccount }) => {
    const dispatch = useDispatch();
    const updatingAccount = useSelector((state) => state.accounts.updatingAccount);

    const [isNone, setIsNone] = useState('');
    const [isLastPeriod, setIsLastPeriod] = useState('');
    const [isSumPeriods, setIsSumPeriods] = useState('');
    const [isWeightedAvgOfNumber, setIsWeightedAvgOfNumber] = useState('');
    const [isWeigthedAvgOfAccount, setIsWeigthedAvgOfAccount] = useState('');
    const [weight, setWeight] = useState('');

    useEffect(() => {
        if (!mainAccount) return;

        mainAccount.sum_type === 'none' ? setIsNone('none') : setIsNone('');
        mainAccount.sum_type === 'lastperiod' ? setIsLastPeriod('lastperiod') : setIsLastPeriod('');
        mainAccount.sum_type === 'sumperiods' ? setIsSumPeriods('sumperiods') : setIsSumPeriods('');
        mainAccount.sum_type === 'weightedavgnumber'
            ? setIsWeightedAvgOfNumber('weightedavgnumber')
            : setIsWeightedAvgOfNumber('');
        mainAccount.sum_type === 'weightedavgaccount'
            ? setIsWeigthedAvgOfAccount('weightedavgaccount')
            : setIsWeigthedAvgOfAccount('');
        mainAccount.sum_type === 'weightedavgnumber' || mainAccount.sum_type === 'weightedavgaccount'
            ? setWeight(mainAccount.weight)
            : setWeight('');
    }, [mainAccount]);

    const handleOk = () => {
        const updateAccount = { ...mainAccount };

        if (isNone === 'none') {
            updateAccount.sum_type = isNone;
            updateAccount.weight = weight;
        } else if (isLastPeriod === 'lastperiod') {
            updateAccount.sum_type = isLastPeriod;
            updateAccount.weight = weight;
        } else if (isSumPeriods === 'sumperiods') {
            updateAccount.sum_type = isSumPeriods;
            updateAccount.weight = weight;
        } else if (isWeightedAvgOfNumber === 'weightedavgnumber') {
            updateAccount.sum_type = isWeightedAvgOfNumber;
            updateAccount.weight = weight;
        } else if (isWeigthedAvgOfAccount === 'weightedavgaccount') {
            updateAccount.sum_type = isWeigthedAvgOfAccount;
            updateAccount.weight = weight;
        }

        if (!updatingAccount) {
            dispatch(accountActions.updateAccount(mainAccount, updateAccount));
        }
        handleCancel();
    };

    const handleCancel = () => {
        setIsChooseSumTypeOpen(false);
    };

    const onChangeSetNone = (e) => {
        setIsNone('none');
        setIsLastPeriod('');
        setIsSumPeriods('');
        setIsWeightedAvgOfNumber('');
        setIsWeigthedAvgOfAccount('');
        setWeight('');
    };

    const onChangeLastPeriod = (e) => {
        setIsNone('');
        setIsLastPeriod('lastperiod');
        setIsSumPeriods('');
        setIsWeightedAvgOfNumber('');
        setIsWeigthedAvgOfAccount('');
        setWeight('');
    };

    const onChangeSumPeriods = (e) => {
        setIsNone('');
        setIsLastPeriod('');
        setIsSumPeriods('sumperiods');
        setIsWeightedAvgOfNumber('');
        setIsWeigthedAvgOfAccount('');
        setWeight('');
    };

    const onChangeWeightedAvgOfNumber = (e) => {
        setIsNone('');
        setIsLastPeriod('');
        setIsSumPeriods('');
        setIsWeightedAvgOfNumber('weightedavgnumber');
        setIsWeigthedAvgOfAccount('');
        setWeight(weight);
    };

    const onChangeWeigthedAvgOfAccount = (e) => {
        setIsNone('');
        setIsLastPeriod('');
        setIsSumPeriods('');
        setIsWeightedAvgOfNumber('');
        setIsWeigthedAvgOfAccount('weightedavgaccount');
        setWeight(weight);
    };

    const renderChooseSumType = () => {
        return (
            <div>
                <Row>
                    <Title level={5} style={{ marginTop: '15px' }}>
                        {' '}
                        {Localization.accountStructure.accountChooseSumNone}{' '}
                    </Title>
                    <Checkbox
                        checked={isNone}
                        style={{ marginTop: '17px', marginLeft: '141px' }}
                        onChange={onChangeSetNone}
                    />
                </Row>
                <Row>
                    <Title level={5} style={{ marginTop: '15px' }}>
                        {' '}
                        {Localization.accountStructure.accountChooseSumPeriod}{' '}
                    </Title>
                    <Checkbox
                        checked={isLastPeriod}
                        style={{ marginTop: '17px', marginLeft: '95px' }}
                        onChange={onChangeLastPeriod}
                    />
                </Row>
                <Row>
                    <Title level={5} style={{ marginTop: '15px' }}>
                        {' '}
                        {Localization.accountStructure.accountChooseSumPeriods}{' '}
                    </Title>
                    <Checkbox
                        checked={isSumPeriods}
                        style={{ marginTop: '17px', marginLeft: '84px' }}
                        onChange={onChangeSumPeriods}
                    />
                </Row>
                <Row>
                    <Title level={5} style={{ marginTop: '15px' }}>
                        {' '}
                        {Localization.accountStructure.accountChooseSumWeightedAvgNumber}{' '}
                    </Title>
                    <Checkbox
                        checked={isWeightedAvgOfNumber}
                        style={{ marginTop: '17px', marginLeft: '28px' }}
                        onChange={onChangeWeightedAvgOfNumber}
                    />
                </Row>
                <Row>
                    <Input
                        style={{ width: '202px' }}
                        disabled={!isWeightedAvgOfNumber}
                        onChange={(e) => setWeight(e.target.value)}
                        value={isWeightedAvgOfNumber ? weight : ''}
                    />
                </Row>
                <Row>
                    <Title level={5} style={{ marginTop: '15px' }}>
                        {' '}
                        {Localization.accountStructure.accountChooseSumWeightedAvgAccount}{' '}
                    </Title>
                    <Checkbox
                        checked={isWeigthedAvgOfAccount}
                        style={{ marginTop: '17px', marginLeft: '47px' }}
                        onChange={onChangeWeigthedAvgOfAccount}
                    />
                </Row>
                <Row>
                    {isWeigthedAvgOfAccount && (
                        <AccountPickerByNumber
                            accountStructure={accountStructure}
                            value={weight || undefined}
                            onChange={(value) => setWeight(value || '')}
                            style={{ width: '280px' }}
                        />
                    )}
                </Row>
            </div>
        );
    };

    return (
        <Modal
            bodyStyle={{
                minHeight: '25vh',
                display: 'flex',
                flexDirection: 'column',
            }}
            style={{
                minWidth: '45vh',
                display: 'flex',
                justifyContent: 'center',
            }}
            title={Localization.accountStructure.accountChooseSumType}
            visible={isChooseSumTypeOpen} // not deprecated in our version
            onOk={handleOk}
            confirmLoading={false}
            onCancel={handleCancel}
        >
            {renderChooseSumType()}
        </Modal>
    );
};

export default ChooseSumType;
